export default {
    'header': {
        'Flights': 'Flights',
        'Booking Status' : 'Booking Status',
        'Contact': 'Contact'
    },
    'general': {
        "Back": "Back",
        'Close': 'Close',
        'Edit': 'Edit',
        'Delete': 'Delete',
        'Send': 'Send',
        'Cancel': 'Cancel',
        'Confirm': 'Confirm',
        'E-Mail': 'E-Mail',
        'Example E-Mail': 'Example john.doe@gmail.com',
        'Phone': 'Phone',
        'Update': 'Update',
        'Error request': 'There was an error during the request. Please retry',
        'First Name': 'First name',
        'Last Name': 'Last name',
        'Name': 'Name',
        'Example Last Name': 'Example Doe',
        'Example First Name': 'Example John',
        'Mr': 'Mr.',
        'Miss': 'Miss',
        'Mrs': 'Mrs.',
        'Title': 'Title',
        'Country': 'Country',
        'Date of Birth': 'Date of Birth',
        'Example Address': 'Example Tower Bridge Rd',
        'Address': 'Address',
        'City': 'City',
        'Example City': 'Example London',
        'Zip Code': 'Zip Code',
        'Example Zip Code': 'Example SE1 2UP',
        'Company Name': 'Company Name',
        'Example Company Name': 'Example ACME Limited',
        'Voucher': 'Voucher',
        'Example Voucher': 'EXAMPLECODE',
        'Are you sure?': 'Are you sure?',
        'Message': 'Message',
        'Market': 'United Kingdom',
        'from Market': 'from the United Kingdom',
        'to Market': 'to the United Kingdom',
        'Open': 'Open',
        "Photo credits": "Photo credits",
        "Continue": "Continue",
        "and": "and",
        'Password': 'Password',
        'Password Confirm': 'Password Confirm',
        'Example Booking code': 'For example 1A2B3C4D5E6F7G8',
        'Product': 'Product',
        'Gender': 'Gender',
        'Male': 'Male',
        'Female': 'Female',
        'Company VAT':'Company VAT',
        'Example Company VAT':'GB123456789',
        'Booking Code': 'Booking Code',
        'Verify': 'Verify',
        'Your Name': 'Your Name',
        'Your E-Mail': 'Your E-Mail',
        'Your Phone': 'Your Phone',
        'Your Message': 'Your Message',
        'Your Booking Code': 'Your Booking Code',
    },
    'validation': {
        'Password not safe enought': 'The Password is not safe enough',
        'Accept terms error': 'We can\'t process your order if you don\'t accept our terms',
        'Please use only latin letters':'Please use only latin letters',
        "The credit card field is required": "The card number field is required",
        "The security code is required": "The security code is required",
        "The expiration data is required": "The expiration data is required",
        "phone_invalid": "The phone number is invalid"
    },
    'date': {
        'January': 'January',
        'February': 'February',
        'March': 'March',
        'April': 'April',
        'May': 'May',
        'June': 'June',
        'July': 'July',
        'August': 'August',
        'September': 'September',
        'October': 'October',
        'November': 'November',
        'December': 'December',
        'Day': 'Day',
        'Month': 'Month',
        'Year': 'Year'
    },
    'search-flight': {
        'Anywhere' : 'Anywhere',
        'Show results containing this flight': 'Show results containing this flight',
        'Number results': '{results} flights',
        'Passengers & Class': 'Passengers & Class',
        'Book Now':'Book Now',
        'Marketing Cheapest': 'Cheapest',
        'Marketing Quickest': 'Fastest',
        'Marketing Best': 'Best Value',
        'roundtrip': 'Roundtrip',
        'oneway': 'One way',
        'From': 'From',
        'To': 'To',
        'From airport': 'Departure airport',
        'To airport': 'Destination airport',
        'Airport or City': 'Airport or City',
        'Passengers': 'Passengers',
        'Adults': 'Adults',
        'Adults Information': 'More than 12 years',
        'Children': 'Children',
        'Children Information': '2 - 12 years',
        'Infants': 'Infants',
        'Invert Departure with Destination': 'Invert Departure with Destination',
        'Infants Information': 'Less than 2 years',
        'Passengers Adults': '{adults} adult|{adults} adults',
        'Passengers Total': '{passengers} passenger | {passengers} passengers',
        'Travelclass economy': 'Economy',
        'Travelclass premium': 'Premium',
        'Travelclass first': 'First',
        'Travelclass business': 'Business',
        'Departure': 'Departure',
        'Return': 'Inbound',
        'Departure Date': 'Departure',
        'Return Date': 'Return',
        'Search': 'Search',
        'Autocomplete No Result': 'No airports/cities found',
        'Travelclass': 'Travel class',
        'Select a travelclass for your search': 'Select a travelclass for your search',
        'Confirm': 'Confirm',
        'Create price alert': 'Create price alert',
        'Outward': 'Outbound',
        'Outbound Flights': 'Outbound Flights',
        'Inbound Flights': 'Inbound Flights',
        'Details': 'Details',
        'price per passenger': 'price per passenger',
        'final price without commission': 'Fare for a passenger | Fare for {n_pax} passengers',
        'final price': 'final price',
        'price per passenger without commission': 'price per passenger + {commission} of service tax',
        'final price without commission amount': 'Fare for a passenger + {commission} of service tax | Fare for {n_pax} passengers + {commission} of service tax',
        'Continue': 'Continue',
        'Filter Stops': 'Stops',
        'Filters Any Stop': 'Any Stop',
        'Filters 1 Stop': '1 Stop',
        'Filters 2 Stops': '2 Stops',
        'Filters 3 Stops': '3 Stops',
        'Filters Direct Flight': 'Direct Flight',
        'Filter Duration': 'Duration',
        'Duration': 'Duration',
        'Filter Stop duration': 'Stop duration',
        'Filter Price Range': 'Price Range',
        'Filter Departure': 'Departure',
        'Filter Return': 'Return',
        'Filter Time Departure': 'Time Departure',
        'Filter Time Arrival': 'Time Arrival',
        'Filter Carriers': 'Carriers',
        'Filter Results': 'Filter Results',
        'Filters': 'Filters',
        'Direct': 'Direct',
        '1 Stop': 'Stop in {stop}',
        '2 Stops': 'Stops in {stop1} and {stop2}',
        '3 Stops': '3 Stops',
        'Duration just h': '{hour}h',
        'Duration just m': '{min}m',
        'Duration h and m': '{hour}h {min}m',
        'Some suggestions based on your position': 'Some suggestions based on your position',
        'Digit 3 characters and select from the list': 'Digit 3 characters and select from the list',
        'Departure date cant be empty':'Select a departure date',
        'Select a departure':'Select a departure airport or city',
        'Sorry no airports or city found': 'Sorry no airports or city found',
        'Alert Update about this route': 'Get updates about this search',
        'Activate an alert': 'Activate an alert',
        'Send me a notification': 'Send me a notification',
        'Everyday': 'Everyday',
        'Every two days': 'Every two days',
        'Every three days': 'Every three days',
        'Every five days': 'Every five days',
        'Every week': 'Every week',
        'Every two weeks': 'Every two weeks',
        'Details Flight': 'Flight details',
        'Details Flights': 'Flight details',
        'Order by Best': 'Order by Best',
        'Order by Price': 'Order by Price',
        'Order by Duration': 'Order by Duration',
        'Different airport': 'The arrival will be on {arrival} and the departure will be on {departure}',
        'Stop segment just h': 'Stop of {hour}h',
        'Stop segment just h in airport': 'Stop of {hour}h in {airport}',
        'Stop segment just m': 'Stop of {min}m',
        'Stop segment just m in airport': 'Stop of {min}m in {airport}',
        'Stop segment h and m': 'Stop of {hour}h {min}m',
        'Stop segment h and m in airport': 'Stop of {hour}h {min}m in {airport}',
        'No Results First Row': 'oh no...',
        'No Results Second Row': 'it looks that no flight',
        'No Results Third Row': 'is available',
        'No Results Filters First Row': 'oh no...',
        'No Results Filters Second Row': 'it looks that no flight',
        'No Results Filters Third Row': 'is available',
        'Alternative next_departure_day': 'Departure on next day',
        'Alternative next_return_day': 'Return on next day',
        'Alternative closer_departure': 'Departure on closer airport',
        'Alternative closer_destination': 'Arrival on closer airport',
        'Alternative different_route': 'Different airports',
        'Alternative different_days': 'Different days',
        'Alternative different_day': 'Different day',
        'Segment 1': 'Direct flight',
        'Segment 2': '1 Stop',
        'Segment 3': '2 Stops',
        'Segment 4': '3 Stops',
        'All flights': 'All flights',
        'Combination with multiple companies': 'Multiple companies',
        'Remove some filter to have more results': 'Remove some filter to have more results',
        'No Results Filter First Row': 'No result present with',
        'No Results Filter Second Row': 'current filters setted',
        'No Results Filter Third Row': 'Remove some filters or change date of the trip',
        'Plus 1 day': '+1 day',
        'Plus X days': '+{days} days',
        'Departure date': 'Departure date',
        'Return date': 'Return date',
        'Edit': 'Edit',
        'Filter results': 'Filter results',
        'Back on top': 'Back on top',
        'Best solution': 'Best Value',
        'Cheapest': 'Cheapest',
        'Fastest': 'Fastest',
        'Order by': 'Order by',
        'Order': 'Sort',
        'Price Alert': 'Price Alert',
        'Price Calendar': 'Price Calendar',
        'Calendar': 'Calendar',
        'Prices starting at price': 'Prices starting at {price}',
        'Order by Departure Hour': 'Order by departure hour',
        'Order by Arrival Hour': 'Order by arrival hour',
        'Departure Hour': 'Departure Hour',
        'Arrival Hour': 'Arrival Hour',
        'Long stop info': 'Long stop',
        'Short stop info': 'Short shop',
        'Deactivate alert': 'Deactivate alert',
        'Deactivate Alert about this route': 'Are you sure you want to deactivate the alert for this search?',
        'Alert is now deactivated': 'Alert is now deactivated',
        'Overnight stops': 'Overnight stops',
        'Destinations from city': 'Flights from {departure}',
        'Prices indicated map': 'The prices are per passenger and are indicative.',
        'Prices approximated': 'Prices shown per passenger. Some prices are approximate and will be recalculated by selecting the destination.',
        'Popularity': 'Popularity',
        'Order by Popularity': 'Order by Popularity',
        'Further': 'Further',
        'Order by Further': 'Order by Further',
        'Closest': 'Closest',
        'Order by Closest': 'Order by Closest',
        'Departure and destination same': 'Departure and destination can\'t be the same',
        'Updated X': 'Updated {when}',
        'Departure Airports': 'Departure Airports',
        'Destination Airports': 'Destination Airports',
        'You can try to choose an alternative search':'You can try to choose an alternative search',
        'Filter Times':'Times',
        'Filter Airports': 'Airports',
        'Select all':'Select all',
        'Deselect all':'Deselect all',
        'Airline Only':'Only',
        'Next Day':'Next Day',
        'Previous Day':'Previous Day',
        'Load other results':'Load more results',
        'Stay X nights': '{nights} night in {destination}|{nights} nights in {destination}',
        'Arrival in X': 'Arrival in {airport}',
        'Loading results': 'We are searching the availability on over 400 airlines'
    },
    'range': {
        'From Minutes To Minutes': 'From {0} to {1}',
        'From Time To Time': 'From {0} to {1}',
        'From': 'From',
        'To': 'to'
    },
    'filter': {
        'departure': 'Departure',
        'return': 'Return'
    },
    'duration': {
        'just h': '{hour}h',
        'Just h': '{hour}h',
        'h and m': '{hour}h {min}m',
        'just m': '{min}m',
        'Just m': '{min}m'
    },
    'features': {
        'Clear Prices': 'Clear Prices',
        'Clear Prices description': 'From the first page you can see the real price of the flight, no tricks here.',
        'Exclusive Combinations' : 'Exclusive Combinations',
        'Exclusive Combinations description': 'All airlines, all fares, exclusive combinations made by Any Flight',
        'Exclusive routes': 'Smart bundle',
        'Exclusive routes description': 'We combine different airlines and routes to offer you a large choice of solutions and lowest prices on the market.',
        'Best support': 'Best support',
        'Best support description': 'We speak your languages, we can help you in case of problems',
        'Security': 'Security',
        'Security description': 'Website protected with best technology and safe to use.',
    },
    'alert': {
        'Receive alert': 'Receive alert',
        'Daily': 'Daily',
        'Weekly': 'Weekly',
        'Every Two Weeks': 'Every Two Weeks',
        'Alert is now active': 'You request was successfully. Now alert is active.'
    },
    'booking': {
        "Price per passenger" : "{price} per passenger",
        "Loading booking": "We are confirming the price with the airline",
        "Booking":"Booking",
        "Cvv":"Security code",
        "Card holder":"Card holder",
        "Example Card holder":"John Doe",
        "This page is 100% safe":"This page is 100% safe",
        "Secure":"Safe page",
        "Safe transmission data":"Your personal data are protected by secure transmission and encrypted storage.",
        "You will be redirected to Coinbase page to complete the payment":"To complete your purchase with cryptocurrency, you will be redirected to the Coinbase payment platform where you can choose from various safe and reliable cryptocurrency options.",
        "Expiration":"Expiration date",
        "Info CVV":"The cvv/cvc2 is usually found on the back of the card and consists of three numbers. In the example 123.",
        "Info Expiration": "The expiry date is usually located on the front of the card. It consists of month and year. In the example 10/28.",
        "Next step":"Next step: {step}",
        "Taxes and fees included":"Taxes and fees included",
        "Rush Message": "The more you wait, the higher the fare! Book it now and save on the price.",
        "Booking Expired":"Booking Expired",
        "Booking is Expiring":"Booking is Expiring",
        "Booking Expired Message":"We are sorry but the time to complete the reservation is expired and we need to revalidate the search.",
        "Booking Is Expiring Message": "Time to complete your booking is running out. Please complete your booking as soon as possible.",
        "Remaining time": "<b>Remaining time:</b> {time}",
        "Title non refundable": "Not refundable ticket",
        "Title refundable": "Partially refundable ticket",
        "Debit or Credit Card": "Debit or Credit Card",
        'Info not refundable': 'If you wish to cancel this ticket after it was purchased, the airline will not refund the paid amount.',
        'Info refundable': 'If you wish to cancel this ticket after it was purchased, the airline will refund the remaining amount after deduction of all the applicable penalties and service fees, if any.',
        "Transfer to airport": "Self-transfer to {airport}",
        "If you are travelling hold luggage you need to collect your luggage and re-check it": "If you have checked-in baggage, you will have to collect it and present it again at check-in",
        "You need to collect your luggage and re-check it": "You have to collect luggage and present it again at check-in",
        'Flight conditions': 'Flight conditions',
        'Not selected': 'Not selected',
        'No priority boarding': 'No priority boarding',
        'Priority boarding': 'Priority boarding',
        'Cabin luggage': 'Cabin luggage',
        'We are checking the price for the chosen trip': 'We are checking the price for the chosen trip',
        'We are working out the final quote for your trip': 'We are working out the final quote for your trip. Shortly you will be asked to enter any relevant passenger details and you will be able to choose additional services, if available.',
        'Flight from X to Y': 'Flight from {departure} to {destination}',

        'Marketing Best Price': 'You have found the <b>cheapest fare to fly to {destination}</b>',
        'Marketing Best Duration': 'You have found the <b>shortest flight to {destination}</b>',
        'Marketing Best Price 10': 'You have found one of the <b>cheapest flight to {destination}</b>',
        'Marketing Best Price 20': 'You have found one <b>flight to {destination} with a good price</b>',
        'Marketing Best Duration 10': 'You have found one of the <b>quickest flight to {destination}</b>',
        'Marketing Best Duration 20': 'You have found a <b>short flight to {destination}</b>',
        'Marketing 1 Interested': 'One person is interested to this trip',
        'Marketing More Interested': '<b>{count} persons</b> are interested in this trip',

        'Contact Details': 'Contact Details',
        'Lead Passenger': 'Lead Passenger',
        'X Passenger': 'Passenger {count}',
        'Passenger': 'Passenger',
        'At least one adult is required': 'At least one adult is required',
        'adult': 'Adult',
        'child': 'Child',
        'children':'Children',
        'infant': 'Infant',
        'infants': 'Infants',
        'Title': 'Title',
        'Hold Luggage': 'Hold Luggage',
        'Hold Luggage section': 'Hold Luggage',
        'Hand Luggage': 'Hand Luggage',
        "Hand Luggage section": 'Hand Luggage',
        "Small Hand Luggage section": 'Small Hand Luggage',
        'Select option luggage': 'Choose the flight and the option for every flight:',
        'Add Passenger': 'Add Passenger',
        'Continue': 'Continue',
        'Update type customer to adult': 'We updated the type of passenger to adult',
        'Update type customer to child': 'We updated the type of passenger to child',
        'Update type customer to infant': 'We updated the type of passenger to infant',
        'Error too many infants': 'You can\'t have only infants then adults in one reservation',
        'Error too many passengers': 'You can\'t have more then 9 passengers in one reservation',
        'Error at least a 16 is required': 'At least one passenger with 16 yrs old is required',
        'Additional services': 'Additional services',
        'Automatic Check-In': 'Check&Go',
        'Automatic Check-In Info': 'We will send you your boarding pass via email. That easy! Hassle free and always in time for your flight.',
        'Travel Insurance': 'Travel Insurance',
        'Travel Insurance Info': 'Travel Insurance',
        'Luggage Insurance': 'Luggage Insurance',
        'Luggage Insurance Info': 'Just one insurance covers all bags of one passenger. In case of 96h delay of your bag, it will pay you €1000.',
        'Disruption Protection': 'Flight Compensation',
        'Disruption Protection Info': 'In case of disruptions caused by the airline, you will receive compensation of up to 600 euros per passenger.',
        'Provided by Name': 'provided by {name}',
        'Terms and conditions': 'Terms and conditions',
        'Passengers': 'Passengers',
        'Summary and payment': 'Summary and payment',
        'Contacts': 'Contacts',
        'Personal': 'Personal',
        'Company': 'Company',
        'Billing data': 'Billing Information',
        'Voucher code': 'Voucher code',
        'Credit Card': 'Credit Card',
        'Card number': 'Card number',
        'Card Holder': 'Card Holder',
        'We are processing the payment': 'We are processing the payment',
        'This operation will last just some seconds': 'This operation will last just some seconds',
        'Retry payment': 'Retry payment',
        'An error occurred during the elaboration of your payment': 'An error occurred during the elaboration of your payment:',
        'Order complete': 'Order #{internal_code} complete',
        'Your order is now complete': 'Your order is now complete, you should have received also a confirmation via E-Mail and SMS.',
        'Confirmation order': 'In max 24 hours you will receive ',
        'adults': 'Adults',
        'Price details': 'Price details',
        'Includes commission': 'Includes commission',
        'Total': 'Total',
        'Subtotal': 'Subtotal',
        "Taxes and fees excluded" : "Taxes and fees excluded",
        "Service and Administration Taxes" : "Service and Administration Taxes",
        'Price changed': 'Price of your reservation changed',
        'Aircompany increased price of reservation': 'Unfortunately the aircompanies have just changed the price for your reservation.',
        'CVC': 'CVC',
        'Old price': 'Old price',
        'New price': 'New price',
        'Accept current price': 'Accept current price',
        'Or you can select an alternative': 'Or you can select an alternative',
        'Show all results': 'Show all results',
        'No luggage': 'No luggage',
        'Boarding priority included': 'Boarding priority included',
        'Small luggage': 'Small luggage',
        'Luggage': 'Luggage',
        'Free': 'Free',
        'Single Luggage': '1 Hold Luggage',
        'Multiple Luggage': '{count} Hold Luggage',
        'Single Hand Luggage': '1 Hand Luggage',
        'Multiple Hand Luggage': '{count} Hand Luggage',
        'Single Priority boarding': '1 Priority Boarding',
        'Multiple Priority boarding': '{count} Priority Boardings',
        'All information related to this passenger will be removed': 'All information related to this passenger will be removed.',

        'Add check-in': 'Add Check&Go for {price} per passenger',
        'No check-in': 'I don\'t need Check&Go',
        'Add insurance per day': '{price} per day',
        'Add insurance': '{price} in total',
        'Compensation of': 'Compensation of {amount}',
        'Add per passenger': 'Add for {price} per passenger',
        'Flight Disruption': 'Disruption Protection',
        'Flight Compensation': 'Flight Compensation',
        'Operated by': 'Operated by {aircompany}',
        'Short stop': 'Short stop info',
        'Small personal item': 'Small personal item',

        'Show only some options': 'Show only some options',
        'Show all options': 'Show all options',
        'Select your baggage': 'Select your baggage',
        'Personal baggage': 'Personal baggage',
        'Hand baggage': 'Hand baggage',
        'Included': 'Included',
        'Small Hand Luggage information short' : 'A small baggage that can be fit under the seat in front your chair.',
        'Hand Luggage information short' : 'A hand baggage that can be fit in the cabinet on top of the seat.',
        'No Hand Luggage': 'No Hand Luggage',
        'Includes also priority boarding for': 'Includes also priority boarding for',

        'Payment': 'Payment',
        'Payment information': 'Payments on our website are protected by the highest SSL technology.',
        'Credit Card Visa/Mastercard': 'Credit Card Visa/Mastercard',
        'American Express': 'American Express',
        'Pay using your credit or debit card Visa or Mastercard': 'Pay using your credit or debit card Visa or Mastercard',
        'Pay using your credit or debit card American Express': 'Pay using your credit or debit card American Express',
        'Pay using your credit or debit card': 'Pay using your credit or debit card Visa, Mastercard or American Express',
        'Cryptocurrencies': 'Cryptocurrencies',
        'Pay using your Bitcoin, Bitcoin Cash, Dai, Dodge coin, Etherum or USD Coin wallet': 'Pay using your Bitcoin, Bitcoin Cash, Dai, Dodge coin, Etherum or USD Coin wallet',
        'Terms & Conditions': 'Terms & Conditions',
        'Small Luggage': 'Small Luggage',
        'Priority': 'Priority',

        'Just bought my ticket to city': 'Just bought my ticket to <u>#{city}</u>',
        'Just bought my ticket to city plain': 'Just bought my ticket to #{city} #ninjatrip',
        'Share on Facebook': 'Share on Facebook',
        'Share on Twitter': 'Share on Twitter',
        'Download image': 'Download image',
        'Share on Whatsapp': 'Share on Whatsapp',
        'Fare rule': 'Fare rule',
        'No hold luggage': 'No hold luggage',
        'Warning': 'Warning',
        'Exclusive solution made by Ninja Trip': 'This exclusive solution is made by Ninja Trip. It includes different flights from one or more air companies that are not normally sold together.',
        'Exclusive solution made by Ninja Trip 2': 'This exclusive solution is made by Ninja Trip.',
        'If you have hold luggage you need to collect it and recheck it': 'If you have hold luggage you need to collect it and recheck it.',
        'In case of cancellation of one segment, there can’t be a refund on the remaining flights': 'In case of cancellation of one segment, there can’t be a refund on the remaining flights.',
        'In case of delay you may miss the connecting flight and the company may not reprotect you on another flight': 'In case of delay you may miss the connecting flight and the company may not reprotect you on another flight. Also if the airline is the same.',
        'In some airports there isn’t a “connection” path and you may need to redo the security checks and it may be required a visa': 'In some airports there isn’t a “connection” path and you may need to redo the security checks and it may be required a visa.',
        'Select option hand luggage': 'Select your preference for hand luggage:',
        'Select option hold luggage': 'Select your preference for hold luggage:',
        'I dont want this service': 'I don\'t want this service',

        'Booking code': 'Booking code',
        'Select passenger': 'Select passenger',
        'Payment was made': 'Payment of {amount} was made via {payment}.',
        'Discount': 'Discount',
        'Complete purchasing': 'Complete booking',

        'Accept terms and conditions': 'I read and accept terms and conditions, terms of Smart Bundle and service agreement',
        'Accept receive messages': 'I want to receive free vouchers, deals and best offers',
        'Tracking and delivery of luggage': '<b>Tracking and delivery of luggage</b> within 96 hrs',
        'Compensation of x in case': '<b>Compensation of {amount}</b> in case of luggage lost',
        'No need of proofs':'<b>No need of proofs</b>',
        'All luggage includes':'<b>All luggage included</b>',
        'No insurance':'No insurance',
        'Flight cancellation message': '<b>Up to 600€ of compensation</b> in case of flight cancellation',
        'Flight delayed message': '<b>Up to 600€ of compensation</b> in case of flight delay > 3 hrs',
        'Flight overbooking message': '<b>Up to 600€ of compensation</b> in case of overbooking',
        'departure': 'Departure',
        'return': 'Return',
        'Included in the price':'Included in the price',
        'Copy from Passenger': 'Copy passenger details',
        'Total Price':'Total Price',
        'Complete the form to book': 'Fill out the form and book your flight!',
        'Step Search':'Search',
        'Step Passengers':'Passengers Details',
        'Step Additional Services':'Additional Services',
        'Step Summary and Payment':'Summary and Payment',
        'Step Complete':'Complete',
        'Back to Search Results':'Back to Search Results',
        'Booking Details':'Booking Details',
        'Select':'Select',
        'Hand Luggage information':'Hand luggage can be taken onboard, can contain liquids not more than 100ml/recipient and has a limit of size and weight.',
        'Hold Luggage information':'Checked luggage is transported only on hold, can contain liquids and has to be dropped off at the airport counter before the flight.',
        'Small Hand Luggage information':'Small hand luggage can be taken onboard, can contain liquids not more than 100ml/recipient and has a limit of size and weight and must be positioned mandatory under the front seat or on top if no space is available.',
        'Remove Passenger':'Remove Passenger',
        '1 Hold Luggage':'1 Hold Luggage',
        '1 Hand Luggage':'1 Hand Luggage',
        'X Hold Luggage':'{count} Hold Luggage',
        'X Hand Luggage':'{count} Hand Luggage',
        'per passenger': 'per passenger',
        'Hold baggage': 'Hold baggage',
        'Hold Luggage information short': 'Hold luggage is transported only on hold, it will be dropped off at the airport counter before the flight.',
        'Add service':'Add service',
        'No Hold Luggage' : 'No Hold Luggage',
        'Remove service':'Remove service',
        'Disruption Protection Terms': 'Service provided by Trouble Flight, clicking add you approve <a href="{link}" target="_blank">terms and conditions</a>',
        'Luggage Insurance Terms': 'Service provided by Blue Ribbon Bags, clicking add you approve <a href="{link}" target="_blank">terms and conditions</a>',
        'Automatic Check-In On Time':'Check-In <b>always on time</b> without fees',
        'Automatic Check-In In your EMail':'Boarding Pass <b>sent directly to your E-Mail</b>',
        'Automatic Check-In Terms': 'Clicking add you approve <a href="{link}" target="_blank">terms and conditions</a>',
        'Only X price': 'only {price}',
        'Your data are encrypted and safe':'Your data are encrypted and safe',
        'You can pay with':'Accepted currencies:',
        'Summary':'Summary',
        'Terms auto accepted':'Completing the order I declare that I’ve read and accepted <a href="{link}" target="_blank">terms and conditions, terms of Smart Bundle and service agreement</a>.',
        'kg':'kg.',
        'Call us info': 'Do you have a question? Call us',
        'Automatic Check-In Short Description': 'Receive your boarding pass for your flight in your email',
        'Automatic Check-In Description': 'In your email, always on time',
        'Disruption Protection Short Description': 'Up to 600€ in case of delay, cancellation or overbooking',
        'Disruption Protection Description': 'No commission, 100% refund',
        'Track your lost luggage': 'Track your lost luggage',
        'Track your lost luggage Short Description': 'Find your lost luggage or get 1000€ of compensation',
        'Track your lost luggage Description': 'Service by Blue Ribbon Bags',
        "Payment Card": "Card",
        "Payment Crypto": "Crypto",
        "Payment Wallet": "Wallet",
        "Complete purchasing on X": "Complete purchasing on {supplier}",
        "After submission, you will be redirected to supplier to complete next steps": "After submission, you will be redirected to {supplier} to complete next steps.",
        "Thank you for your order!": "Thank you for your order!",
        "The order confirmation has been sent to your email address" : "The order confirmation has been sent to your email address",
        "Payment of AMOUNT accepted": "Payment of {amount} accepted",
        "Booking Status" : "Booking Status",
        "Remove": "Remove"
    },
    'booking-errors': {
        'account_closed':
            'The bank account has been closed.',
        'account_frozen':
            'The bank account has been frozen.',
        'bank_account_restricted':
            'The bank account has restrictions on either the type, or the number, of payouts allowed.',
        'bank_ownership_changed':
            'The destination bank account is no longer valid because its branch has changed ownership.',
        'could_not_process':
            'The bank could not process this payout.',
        'debit_not_authorized':
            'Debit transactions are not approved on the bank account.',
        'card_declined':
            'The bank has declined this transfer. Please contact the bank before retrying.',
        'insufficient_funds':
            'Your Stripe account has insufficient funds to cover the payout.',
        'invalid_account_number':
            'The routing number seems correct, but the account number is invalid.',
        'incorrect_account_holder_name':
            'Your bank notified us that the bank account holder name on file is incorrect.',
        'incorrect_account_holder_address':
            'Your bank notified us that the bank account holder address on file is incorrect.',
        'incorrect_account_holder_tax_id':
            'Your bank notified us that the bank account holder tax ID on file is incorrect.',
        'invalid_currency':
            'The bank was unable to process this payout because of its currency. This is probably because the bank account cannot accept payments in that currency.',
        'no_account':
            'The bank account details on file are probably incorrect. No bank account could be located with those details.',
        'unsupported_card': 'The bank no longer supports payouts to this card.',
        'Generic error': 'Generic error',
        'payment_intent_authentication_failure': 'Payment failed, please retry',
        'expired_card': 'The card used is no longer valid.',
        'incorrect_cvc': 'CVC/CC2 of your card is not correct.',
        'processing_error': 'Error during payment process'
    },
    'seo' : {
        'Airlines': 'Airlines',
        'Air Companies': 'Air Companies',
        'List of Airlines': 'List of Airlines',
        'Searches': 'Searches',
        'Flights to X': 'Flights to {to}',
        'Some X Flights': 'Some {aircompany} flights',
        'Find the cheapest time to fly to X': 'Find the cheapest time to fly to {to}'
    },
    'seo-flights-to': {
        'Find cheap flight': 'Find cheap flights to {to} Airport with Ninja Trip. Booking flights with Ninja Trip is simple, fast and best of all free to use!',
        'Compare cheap flights': 'Compare cheap flights to {to} Airport by simply using the search box above. The search results will show you the widest range of airlines and travel agents offering cheap flights to {to} Airport anywhere on the web, then you can simply book your flights to {to} Airport directly by clicking through to agency or airline sites.',
        'Chart cheap flights': 'If your travel dates are flexible Ninja Trip can show you the cheapest days in the month to fly to {to} Airport, our graphs show you the best time to fly to {to} Airport so you can really grab yourself a cheap flight.',
        'Bookmark cheap flights': 'If you’ve found a great price on your flights to {to} Airport then bookmark Ninja Trip and come back to search and book for free on hundreds of airlines and thousands of destinations worldwide.',
        'Find cheap flights 2': 'Find the best deal on cheap flights to {to} with Ninja Trip. The minimum price of a flight to Ninja Trip from the {market} is {min_price} but flight prices depend on the availability of seats, the day(s) on which you travel, and when you book.',
        'What airlines': 'What airlines fly to {to} {market}?',
        'Number of airlines': 'A number of airlines offer direct and indirect flights to {to} {market}, often daily, including {airlines}.',
        'City Airports': '{to} airports',
        'City has one airport': '{to} has only one airport: {airports}.',
        'City has more airports': '{to} has {count} airports: {airports}.',
        'Title': 'Flights to {to}',
        'Title it-it': 'Voli per {to}',
        'Title en-gb': 'Flights to {to}',
        'Title en-us': 'Flights to {to}',
        'Title es-es': 'Vuelos a {to}',
        'Title ro-ro': 'Zboruri către {to}',
        'Title ro-md': 'Zboruri către {to}',
        'Title ru-ru': 'рейсы в {to}',
        'Title ru-md': 'рейсы в {to}',
        'Prices for flights from market to destination': 'Prices for flights {market} to {to}',
        'Seo Title': 'Cheap Flights to {to} Airport ({to_code}) from {min_price} - Flight Tickets',
        'Seo Title No Price': 'Cheap Flights to {to} Airport ({to_code}) - Flight Tickets',
        'Seo Description': 'Looking for flights to {to} Airport? Compare airlines and lowcost for cheap {to} flights. Search and save now with Ninja Trip.',
        'Seo Description No Price': 'Looking for flights to {to} Airport? Compare airlines and lowcost for cheap {to} flights. Search and save now with Ninja Trip.',
        'Alt image index': 'Flights to {to} - Photo {index}',
        'Related Airlines': 'Airlines that fly to {to}',
    },
    'seo-flights-from': {
        'Flights from': 'Flights from {from}'
    },
    'seo-flights-to-country': {
        'Some prices of flights from X to Y': 'Some prices of flights {from} to {to}',
        'Some prices same country to Y': 'Some prices of flights to {to}',
        'How long does it take to fly X to Y': 'How long does it take to fly {departure} to {destination}?',
        'The average flight time is hr and mins': 'Considering a flight from {airport_departure} to {airport_destination} the average flight time is {hour} hour {minutes} minutes.',
        'The average flight time is hrs and mins': 'Considering a flight from {airport_departure} to {airport_destination} the average flight time is {hour} hours {minutes} minutes.',
        'The average flight time is hrs': 'Considering a flight from {airport_departure} to {airport_destination} the average flight time is {hour} hours.',
        'The average flight time is hr': 'Considering a flight from {airport_departure} to {airport_destination} the average flight time is {hour} hour.',
        'The average flight time is mins': 'Considering a flight from {airport_departure} to {airport_destination} the average flight time is {minutes} minutes.',
        'What is the price for a flight X to Y': 'What is the price for a flight {departure} to {destination}?',
        'Cheapest price same outward roundtrip' : 'The lowest price for a flight {departure} to {destination} is, for a one way flight from {city_departure} to {city_destination} {price_oneway}, and {price_roundtrip} for roundtrip.',
        'Cheapest price different outward roundtrip' : 'The lowest price for a flight {departure} to {destination} is, for a one way flight from {city_departure_oneway} to {city_destination_oneway} {price_oneway}, and {price_roundtrip} for roundtrip flight from {city_departure_roundtrip} to {city_destination_roundtrip}.',
        'Cheapest price roundtrip':'The lowest price for a flight {departure} to {destination} is {price} for a roundtrip flight from {city_departure} to {city_destination}.',
        'Cheapest price oneway':'The lowest price for a flight {departure} to {destination} is {price} for a oneway flight from {city_departure} to {city_destination}.',
        'Which aircompanies flights X to Y':'Which airlines flies {departure} to {destination}?',
        'Which aircompanies flights direct X to Y':'Which airlines flies direct {departure} to {destination}?',
        'No airlines': 'We currently have no information on airlines operating {departure} to {destination}.',
        'No airlines direct': 'We currently have no information on airlines operating direct flights {departure} to {destination}.',
        'Only one company': 'One airline operates {departure} to {destination}: {aircompanies}.',
        'Only one company direct': 'One airline operates direct flights {departure} to {destination}: {aircompanies}.',
        'Many companies': 'The airlines operating {departure} to {destination} are {aircompanies}.',
        'Many companies direct': 'The airlines operating direct flights {departure} to {destination} are {aircompanies}.',
        'Most popular airline':'Most popular airline',
        'Cheapest price':'Cheapest price',
        'Airports in X':'Airports in {country}',
        'Airport link':'Flights to {destination}',
        'Title':'Flights to {destination}',
        'Subtitle': 'Fly to {destination}'
    },
    'seo-flights-route': {
        'Title': 'Cheap Flights from {from} to {to}',
        'Seo Description': 'Find and book one-way or roundtrip flights from {from} to {to} at the best rate. Find the best deals and discounts. Ninja Trip has the best support team in travel industry.',
        'Chart Title': 'Flights roundtrip from {from} to {to}',
        'Trip duration (days)': 'Trip duration (days)',
        'How many airports in x': 'How many airports are in {city}?',
        'Just airport of X with name': 'There is only one airport in {city}: {name}.',
        'Just airport of X no name': 'There is only one airport in {city}.',
        'There are X airports in X': 'There are {count} airports in {city}: {airports}.',
        'How long does it take to fly from X to Y': 'How long does it take to fly from {departure} to {destination}?',
        'The average flight time is hr and mins': 'The average flight time is {hour} hour {minutes} minutes.',
        'The average flight time is hrs and mins': 'The average flight time is {hour} hours {minutes} minutes.',
        'The average flight time is hrs': 'The average flight time is {hour} hours.',
        'The average flight time is hr': 'The average flight time is {hour} hour.',
        'The average flight time is mins': 'The average flight time is {minutes} minutes.',
        'Which aircompanies offer direct flights from X to Y': 'Which airlines offer direct flight from {departure} to {destination}?',
        'No direct flights': 'Unfortunately, there are no company that offers a direct flight from {departure} to {destination}.',
        'Only one direct company': 'Only one airline that offers a direct flight from {departure} to {destination}: {aircompanies}.',
        'Many direct company': '{count} airlines are offering direct flight from {departure} to {destination}: {aircompanies}.',
        'What is the cheapest time to buy a ticket for a flight from X to Y': 'What is the cheapest time to buy a ticket for a flight from {departure} to {destination}?',
        'What is the price for a flight from X to Y': 'What is the price for a flight from {departure} to {destination}?',
        'The cheapest price is X': 'The cheapest price for a flight from {departure} to {destination} is {price}.',
        'The cheapest price both is X Y': 'The cheapest prices for a flight from {departure} to {destination} are {price_oneway} for oneway and {price_roundtrip} for roundtrip.',
        'The cheapest price roundtrip is X': 'The cheapest roundtrip price for a flight from {departure} to {destination} is {price}.',
        'The cheapest price oneway is X': 'The cheapest oneway price for a flight from {departure} to {destination} is {price}.',
        'No indication price': 'We currently don\'t have any updated statistics, do a search on our website to have real time prices.',
        'Right now we have no indication about the best time to travel from X to Y': 'Right now we don\'t have an indication about the best time to travel from {departure} to {destination}.',
        'Best moment to travel from X to Y is the month of Z': 'Based on our information the most economic month to fly from {departure} to {destination} is {month}.',
        'Closest airport from X are': 'As the crow flies, the closest airports to {airport} are {airports}.',
        'What airports are there near x': 'What airports are there near {city}?',
        'Related airlines': 'Related airlines',
        'Aircompany link': 'Flights {aircompany} to {destination}',
        'Flight Departure Title': 'Flights from {city}',
        'Flight Destination Title': 'Flights to {city}',
        'Some prices of flights from X to Y': 'Some prices of flights from {from} to {to}',
        'Title anchor': 'Flights from {from} to {to}',
        'Title en-gb': 'Flights from {from} to {to}',
        'Title en-us': 'Flights from {from} to {to}',
        'Title it-it': 'Voli da {from} a {to}',
        'Title es-es': 'Vuelos de {from} a {to}',
        'Title ro-ro': 'Zboruri de la {from} către {to}',
        'Title ro-md': 'Zboruri de la {from} către {to}',
        'Title ru-ru': 'Рейсы {from} - {to}',
        'Title ru-md': 'Рейсы {from} - {to}',
        'Reverse trip': 'Reverse trip',
        'Seo Title': 'Cheap Flights from {from} to {to} Airport - {from_code} {to_code} - Flight Tickets'
    },
    'seo-flight': {
        'Flight from to': 'Flight from {from} to {to}',
        'Flight to': 'Flight to {to}'
    },
    'seo-aircompany': {
        'Air Companies': 'Air Companies',
        'Company information': '{aircompany} Information',
        'Average price': 'Average price',
        'Most popular destination': 'Most popular destination',
        'Weekly flights': 'Weekly flights',
        'Country': 'Country',
        'Title': '{aircompany} Flights',
        'Title en-gb': '{aircompany} Flights',
        'Title en-us': '{aircompany} Flights',
        'Title ro-ro': 'Zboruri {aircompany}',
        'Title ro-md': 'Zboruri {aircompany}',
        'Title it-it': 'Voli {aircompany}',
        'Title es-es': 'Vuelos {aircompany}',
        'Title ru-ru': 'полеты {aircompany}',
        'Title ru-md': 'полеты {aircompany}',
        'Title from': '{aircompany} Flights from only {price}',
        'Seo Title': 'Cheap {aircompany} Flights Tickets - NinjaTrip',
        'Seo Title with Price': '{aircompany} Flights Tickets from only {min_price} - NinjaTrip',
        'Alt image index': '{aircompany} Flights - Photo {index}',
        'Seo Description': 'Compare the best flights with {aircompany}. Search and save now with Ninja Trip.',
        'Seo Description No Price': 'Compare the best flights with {aircompany}. Search and save now with Ninja Trip.',
    },
    'share': {
        'Share this offer': 'Share this offer',
        'Share flight': 'Hey check out this flight!',
        'Copy': 'Copy',
        'Share link offer': 'Share link offer',
        'Link copied': 'The link was copied, you can paste it to your friends'
    },
    'footer': {
        'International Websites': 'Our Websites',
        'Other destinations': 'Other destinations',
        'Follow us': 'Follow us',
        'Follow us description': 'Stay tuned and access the latest deals and discounts with:',
        'Ninja Trip': 'Ninja Trip',
        'About Us': 'About Us',
        'Why Us': 'Why Us',
        'Media Room': 'Media Room',
        'Work with us': 'Work with us',
        'Advertising': 'Advertising',
        'Affiliation': 'Affiliation',
        'Copyright': '© {startYear} - {year}. All right reserved. RO44531870 GTM Global Travel Management S.R.L. The services available through the site are offered by GTM Agency or its Partners.',
        'Iata Accredited Agency': 'Iata Accredited Agency',
        'Airlines': 'Airlines',
        'Destinations': 'Destinations',
        'Routes': 'Routes',
        'Reservations': 'Reservations',
        'Support': 'Support',
        'Any Flight': 'Any Flight'
    },
    'support': {
        'Support center': 'Support Centre',
        'Support': 'Support',
        'Warning flights': 'Warning flights',
        'Incident is effecting flights in country': 'Incident is effecting flights in {country}',
        'Incident is effecting flights with aircompany': 'Incident is effecting flights with {aircompany}',
        'Incident is effecting flights at airport': 'Incident is effecting flights at airport {airport}',

        'Incident airline_system_failure': 'Technical problems airport',
        'Incident airport_staff_strike': 'Airport staff strike',
        'Incident atc_and_other_airline': 'Air traffic control strike',
        'Incident aircraft_incidents': 'Aircraft incident',
        'Incident volcano_eruptions': 'Volcanic eruptions',
        'Incident thunderstorms': 'Thunderstorm',
        'Incident snowstorm': 'Snowstorm',
        'Incident terrostic_alert': 'Terroristic alert',
        'Incident war': 'War conflict',
        'Incident bomb_alert': 'Bomb alert',
        'Incident political_unrest': 'Political unrest',
        'Incident floodings': 'Flooding',
        'Incident earthquakes': 'Earthquakes',
        'Incident airline_bankruptcy': 'Airline bankruptcy',
        'Incident airline_strike': 'Airline staff strike',
        'Incident covid19': 'Covid 19 restrictions',
        'Incident airport_incident': 'Airport incident',
        'Incident airport_blackout': 'Airport blackout',
        'Incident atc_and_other_airline-related_bodies': 'Air traffic controller or other airport entity strike',
        'Incident disclamer': 'This list is not to be considered complete, all information provided has no legal value and can only be interpreted as a suggestion.',
        'Contact us': 'Contact us',
        'Send request': 'Send request',
        'Your request was sent': 'Your request was sent. We will answer as soon as possible.',
        'Search on support center': 'Search on Support Centre',
        'Example Search': 'Write something like “check-in”',
        'Search': 'Search',
        'Most common problems': 'Most common problems',
        'Contact Us': 'Contact Us',
        'Search for X': 'Search for "{keyword}"',
        'No articles found': 'No articles found',
        'Not related to a reservation': 'Not related to a reservation',
        'No ID available': 'No ID available',
        'Booking Information': 'Booking Information',
        'Message start': 'Hello Ninja Trip team,\n\n\nThank you',
        'Example Message': '',
        'Problem': 'Problem',
        'Request': 'Request',
        'Send Request': 'Send Request',
        'Thank you for your request': 'Thank you for your request!',
        'We will answer you via E-Mail on email as soon as possible': 'We will answer you via E-Mail on {email} as soon as possible.',
        'Create an account and use all the perks!': 'Create an account and use all the perks!',
        'Fill passengers details once, use it every time': 'Fill passengers details once, use it every time.',
        'One click to fill and download the invoice': 'One click to fill and download the invoice.',
        'Keep track of your trips and tickets': 'Keep track of your trips and tickets.',
        'Automatic check-in or follow easy steps explained to print your boarding pass': 'Automatic check-in or follow easy steps explained to print your boarding pass.',
        'Cant find what you are looking for': 'Can\'t find what you are looking for?',
        'Get support from Ninja Trip':'Get support from Ninja Trip',
        'Contact us description': 'We are here to help you. Contact us by email or by form online.',
    },
    'checkin': {
        'Complete missing data for Check-In': 'Complete missing data for Check-In',
        'Instruction Fill Check-In': 'To complete your check-in some more information are required. To avoid delays please fill the missing information as soon as possible so we will be able to complete your check-in and send it to you immediately as soon it will be available.',
        'Check-in closed': 'Check-in closed',
        'Instruction Check-In Closed': 'We are sorry but the check-in for your reservation is already closed.',
        "passport": "Passport",
        "identity_card": "Identity card",
        "Document type": "Document type",
        "Example Document Number": "AX123456",
        "Document number": "Document number",
        "Date of emission": "Date of emission",
        "Date of expiration": "Date of expiration",
        "Legal info": "Clicking the button \"Continue\" I confirm under my own responsibility that all data entered is correct and that I am aware of the rules on products not allowed on board.",
        "Check-In is already completed": "We already received the information to be able to emit your check-in.",
        "Check-In Completed": "Thank you for completing all the missing information required to emit your check-in.",
        "Check-In When sent": "We will send you the check-in some days prior to the departure, based on the rule of the airline.",
        "Passport":"Passport",
        "Identity Card":"Identity Card",
        "Instructions" : "Fill first and last name exactly like in your passport/identity card or you may be refused. In case you have a second name fill it in “First Name”."
    },
    'partner': {
        'Service offered by Trouble Flight': 'Service offered by Trouble Flight',
        'This service is offered by a partner of Ninja Trip': 'This service is offered by a partner of Ninja Trip.',
        'To speed up the claim process, we can share your booking data with Trouble Flight': 'To speed up the claim process, we can share your booking data with Trouble Flight.',
        'This information includes': 'This information includes:',
        'Passenger names': 'Passenger names',
        'Itinerary booked': 'Itinerary booked',
        'Booking code': 'Booking code',
        'E-mail address and telephone number': 'E-Mail address and telephone number',
        'Continue': 'Continue',
        'Terms': 'By clicking on continue you authorise Ninja Trip (GTM - Global Travel Management S.R.L.) to send your booking information to Trouble Flight (Doorify Tech S.R.L.). Trouble Flight will only use this information to expedite the creation of a claim. After the click, you will be redirected to the Trouble Flight website where you can complete your claim.'
    },
    'job': {
        'Full time role': 'Full time role',
        'X Candidates': '{n} candidates',
        'Candidate for this role': 'Candidate for this role',
        'Candidate for X': 'Candidate for "{role}"',
        'Click to upload your CV': 'Click to upload your curriculum vitae',
        'Curriculum vitae': 'Curriculum vitae'
    },
    'upload': {
        'Single file only': 'Only one file is accepted.',
        'File uploaded correctly': 'File uploaded correctly',
        'X files uploaded correctly': '{n_files} files uploaded correctly'
    },
    'login': {
        "Login":"Login",
        'Instruction Login Sign in': 'Sign in to Ninja Trip or',
        'Instruction Login Create an account': 'create an account',
        'Continue with social': 'Continue with {social}',
        'My Account': 'My Account',
        'Logout': 'Logout',
        'Hello name': 'Hello {name}',
        'Instruction Login Register': 'Let\'s create a new account for you!',
        'Instruction Login Password': 'Enter your Ninja Trip account password',
        'Go back': 'or go back',
        'Hello': 'Hello',
        'Accept Terms and Conditions': 'I have read and agree to the Terms and Conditions, Privacy Policy.',
        'Offers': 'I want to receive the best offers.',
        'Forgotten password': 'Forgotten password',
        'Sent link password': 'We have sent an email with the password reset link to the email address indicated',
        'Welcome': 'Welcome',
        'Instruction Login Reset Password': 'Choose a new safe password',
        'The link is no longer valid': 'The link is no longer valid. Probably too much time passed and it expired.',
        'E-Mail or password wrong': 'E-Mail or password wrong',
        'Confirm E-Mail change': 'Confirm E-Mail change',
        'Profile edited correctly': 'Profile edited correctly',
        'Current Password': 'Current Password',
        'Password changed correctly': 'Password changed correctly',
        'Your session is expired': 'Your session is expired, login again to continue'
    },
    'myaccount': {
        'My upcoming trips': 'My upcoming trips',
        'Flight roundtrip from to': 'Flight roundtrip from {departure} to {destination}',
        'Flight oneway from to': 'Flight oneway from {departure} to {destination}',
        'Checkin opens in date': 'Check-in opens {date}',
        'Checkin is currently open': 'Check-in is currently open',
        'Check In Instructions': 'Check-in instructions',
        'Check In Instructions details': 'In order to travel, you need a boarding pass. Below you can find instructions on how to download them for all the companies on your journey',
        'CheckIn warning': 'In case of multiple PNRs you need to repeat the procedure once for every PNR.',
        'Check in will open x and close y': 'Check-In will open <b>{open}</b> and close <b>{close}</b> before the flight.',
        'Start Check-In': 'Start Check-In',
        'Check-In': 'Check-In',
        'Invoice': 'Invoice',
        'Download invoice X': 'Download invoice {series}{number}',
        'Sign up via E-Mail': 'Sign up via E-Mail',
        'Use another account': 'Use another account',
        'Sign up': 'Sign up',
        'Passengers': 'Passengers',
        'No Passengers First Row': 'Still',
        'No Passengers Second Row': 'no passengers here,',
        'No Passengers Third Row': 'add the first passenger and save time during your reservations',
        'Add Passenger': 'Add Passenger',
        'Edit': 'Edit',
        'Edit Profile': 'Edit Profile',
        'Edit Password': 'Edit Password',
        'Your trip is being confirmed': 'You will receive the booking shortly',
        'No trips': 'Ops, no trip is available...',
        'Details': 'Details',
        'All reservations': 'All reservations',
        'Future reservations': 'Future reservations',
        'Past reservations': 'Past reservations',
        'See': 'See',
        'My trips': 'My trips',
        'Prev page': '« Prev',
        'Next page': 'Next »',
        'Support': 'Support',
        'Product flight': 'Flight'
    },
    'home': {
        'Popular Destinations': 'Popular Destinations',
        'Home': 'Home'
    },
    "booking-status" : {
        "Find Booking": "Find Booking",
        "Processing your booking": "Processing your booking...",
        "We are processing your booking request Please wait": "We are processing your booking request. Please wait",
        "Booking Code": "Booking: {code}",
        "Booking completed": "Booking completed",
        "Thank you for your booking": "Thank you for your booking!",
        "Booking refused" : "Booking refused",
        "We are sorry, but your booking cannot be confirmed": "We are sorry, but your booking cannot be confirmed. Your payment has been refunded.",
        "Payment": "Payment",
        "Payment Method": "Payment Method",
        "Payment Amount": "Payment Amount"
    }
};
